import React from 'react';
import { WebsiteDesignProps } from './types';
import { Frame, PenTool, LayoutTemplate } from 'lucide-react';
import { Button } from "@/components/ui/button";

const ArchitecturalFirm: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Studio Arch";

    return (
        <div className="bg-white min-h-screen font-sans text-black">
            {/* Sidebar Nav */}
            <div className="fixed left-0 top-0 h-full w-20 border-r border-black bg-white flex flex-col justify-between items-center py-8 z-50">
                <div className="bg-black text-white p-2 font-bold text-xl">
                    SA
                </div>
                <div className="writing-vertical-lr transform rotate-180 text-xs font-bold uppercase tracking-widest flex gap-12">
                     <a href="#" className="hover:text-gray-500">Projects</a>
                     <a href="#" className="hover:text-gray-500">Studio</a>
                     <a href="#" className="hover:text-gray-500">News</a>
                </div>
                <div className="h-8 w-1 bg-black"></div>
            </div>

            <main className="pl-20">
                <header className="h-screen relative flex items-center justify-center px-12 border-b border-black">
                    <div className="absolute top-8 right-8 text-right">
                        <div className="text-xs uppercase font-bold tracking-widest mb-1">Architecture & Design</div>
                        <div className="text-4xl font-bold uppercase">{schoolName}</div>
                    </div>
                    
                    <div className="grid grid-cols-2 gap-8 w-full max-w-6xl h-3/4">
                        <div className="flex flex-col justify-end pb-12">
                            <h1 className="text-6xl md:text-8xl font-bold leading-none mb-8 tracking-tighter">
                                Form. <br/> Space. <br/> Order.
                            </h1>
                            <p className="max-w-md text-lg font-medium leading-relaxed">
                                Cultivating a deep understanding of the built environment. We teach the rigorous balance of aesthetics and function.
                            </p>
                            <div className="mt-8">
                                <Button className="rounded-none bg-black text-white px-8 py-6 uppercase tracking-widest text-xs font-bold hover:bg-gray-800">
                                    View Portfolio
                                </Button>
                            </div>
                        </div>
                        <div className="relative h-full w-full bg-gray-100 overflow-hidden">
                            <img src="https://images.unsplash.com/photo-1486718448742-163732cd1544?q=80&w=2070&auto=format&fit=crop" className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700" alt="Architecture" />
                            <div className="absolute bottom-4 right-4 bg-white p-4 border border-black text-xs font-bold uppercase">
                                Fig 01. Structural Integrity
                            </div>
                        </div>
                    </div>
                </header>

                <section className="grid grid-cols-1 md:grid-cols-3 divide-x divide-black border-b border-black">
                    {[
                        { icon: Frame, title: "Structure", desc: "Understanding the skeleton of design." },
                        { icon: LayoutTemplate, title: "Planning", desc: "The strategic arrangement of value." },
                        { icon: PenTool, title: "Drafting", desc: "Precision in every line and curve." }
                    ].map((item, i) => (
                        <div key={i} className="p-12 hover:bg-black hover:text-white transition-colors group h-64 flex flex-col justify-between">
                            <item.icon size={32} className="group-hover:text-white" />
                            <div>
                                <h3 className="text-xl font-bold uppercase mb-2">{item.title}</h3>
                                <p className="text-sm font-medium opacity-60 group-hover:opacity-100">{item.desc}</p>
                            </div>
                        </div>
                    ))}
                </section>
            </main>
        </div>
    );
};

export default ArchitecturalFirm;
